<template>
	<div class="u8-nts-schedule">
		<!-- NTS指标达成率功能区域 -->
		<div class="achieving-rate-section">
			<div class="section-title">产品线NTS达成</div>
			<div class="search-area">
				<div class="search-item">
					<span class="label">年份：</span>
					<el-date-picker v-model="achievingRateForm.Year" type="year" placeholder="选择年份" size="small"
						style="width: 120px" value-format="yyyy" :editable="false"></el-date-picker>
				</div>
				<div class="search-item">
					<span class="label">渠道：</span>
					<el-select v-model="achievingRateForm.AccType" placeholder="请选择渠道" size="small">
						<el-option label="U8" value="U8"></el-option>
						<el-option label="U9" value="U9"></el-option>
					</el-select>
				</div>
				<div class="search-item">
					<span class="label">产品线：</span>
					<el-select v-model="achievingRateForm.InvClass" placeholder="请选择产品线" size="small" multiple
						collapse-tags style="width: 200px;">
						<el-option v-for="option in productLineOptions" :key="option.value" :label="option.label"
							:value="option.value"></el-option>
					</el-select>
				</div>
				<div class="search-item">
					<span class="label">统计维度：</span>
					<el-select v-model="achievingRateForm.ByQuarter" placeholder="请选择维度" size="small">
						<el-option label="月度" value="0"></el-option>
						<el-option label="季度" value="1"></el-option>
					</el-select>
				</div>
				<div class="button-group" style="transform: translateY(-4px);">
					<el-button size="small" @click="handleAchievingRateReset">重置</el-button>
					<el-button type="primary" size="small" @click="handleAchievingRateSearch">搜索</el-button>
					<el-button size="small" class="refresh-btn" @click="handleAchievingRateRefresh"
						:loading="achievingRateRefreshing">刷新</el-button>
				</div>
			</div>

			<div class="content-area achieving-rate-content">
				<el-spinner v-if="achievingRateLoading" style="margin: 20px auto; display: block;"></el-spinner>
				<div v-else-if="achievingRateData.JMonthTD && achievingRateData.JMonthTD.length"
					class="achieving-rate-container">
					<div class="ytd-chart-box">
						<div ref="ytdChart" style="width: 100%; height: 350px;"></div>
					</div>
					<div class="monthly-chart-box">
						<div ref="monthlyChart" style="width: 100%; height: 350px;"></div>
					</div>
				</div>
				<el-empty v-else description="暂无数据"></el-empty>
			</div>

			<!-- 达成率数据表格 -->
			<div class="content-area achieving-rate-content" style="margin-top: 20px;">
				<div style="padding: 15px 20px; text-align: right;">
					<el-button size="small" @click="handleAchievingRateExport">导出</el-button>
				</div>
				<div style="padding: 0 20px 20px;">
					<el-table :data="achievingRateData.listRepost || achievingRateData.listReport || []"
						style="width: 100%" v-loading="achievingRateLoading" border
						:header-cell-style="getAchievingRateHeaderStyle" :row-class-name="tableRowClassName">
						<el-table-column prop="InvClassName" :label="achievingRateData.InvClassName || '产品线'"
							min-width="130" fixed="left" align="center"></el-table-column>
						<el-table-column prop="YTD" label="YTD" min-width="130" align="center">
							<template slot-scope="scope">
								{{ formatTableValue(scope.row.YTD, scope.row, scope.$index) }}
							</template>
						</el-table-column>
						<el-table-column prop="Q1" label="Q1" min-width="130" align="center">
							<template slot-scope="scope">{{ formatTableValue(scope.row.Q1, scope.row, scope.$index)
							}}</template>
						</el-table-column>
						<el-table-column prop="Q2" label="Q2" min-width="130" align="center">
							<template slot-scope="scope">{{ formatTableValue(scope.row.Q2, scope.row, scope.$index)
							}}</template>
						</el-table-column>
						<el-table-column prop="Q3" label="Q3" min-width="130" align="center">
							<template slot-scope="scope">{{ formatTableValue(scope.row.Q3, scope.row, scope.$index)
							}}</template>
						</el-table-column>
						<el-table-column prop="Q4" label="Q4" min-width="130" align="center">
							<template slot-scope="scope">{{ formatTableValue(scope.row.Q4, scope.row, scope.$index)
							}}</template>
						</el-table-column>
						<el-table-column prop="Jan" label="1月" min-width="130" align="center">
							<template slot-scope="scope">{{ formatTableValue(scope.row.Jan, scope.row, scope.$index)
							}}</template>
						</el-table-column>
						<el-table-column prop="Feb" label="2月" min-width="130" align="center">
							<template slot-scope="scope">{{ formatTableValue(scope.row.Feb, scope.row, scope.$index)
							}}</template>
						</el-table-column>
						<el-table-column prop="Mar" label="3月" min-width="130" align="center">
							<template slot-scope="scope">{{ formatTableValue(scope.row.Mar, scope.row, scope.$index)
							}}</template>
						</el-table-column>
						<el-table-column prop="Apr" label="4月" min-width="130" align="center">
							<template slot-scope="scope">{{ formatTableValue(scope.row.Apr, scope.row, scope.$index)
							}}</template>
						</el-table-column>
						<el-table-column prop="May" label="5月" min-width="130" align="center">
							<template slot-scope="scope">{{ formatTableValue(scope.row.May, scope.row, scope.$index)
							}}</template>
						</el-table-column>
						<el-table-column prop="Jun" label="6月" min-width="130" align="center">
							<template slot-scope="scope">{{ formatTableValue(scope.row.Jun, scope.row, scope.$index)
							}}</template>
						</el-table-column>
						<el-table-column prop="Jul" label="7月" min-width="130" align="center">
							<template slot-scope="scope">{{ formatTableValue(scope.row.Jul, scope.row, scope.$index)
							}}</template>
						</el-table-column>
						<el-table-column prop="Aug" label="8月" min-width="130" align="center">
							<template slot-scope="scope">{{ formatTableValue(scope.row.Aug, scope.row, scope.$index)
							}}</template>
						</el-table-column>
						<el-table-column prop="Sep" label="9月" min-width="130" align="center">
							<template slot-scope="scope">{{ formatTableValue(scope.row.Sep, scope.row, scope.$index)
							}}</template>
						</el-table-column>
						<el-table-column prop="Oct" label="10月" min-width="130" align="center">
							<template slot-scope="scope">{{ formatTableValue(scope.row.Oct, scope.row, scope.$index)
							}}</template>
						</el-table-column>
						<el-table-column prop="Nov" label="11月" min-width="130" align="center">
							<template slot-scope="scope">{{ formatTableValue(scope.row.Nov, scope.row, scope.$index)
							}}</template>
						</el-table-column>
						<el-table-column prop="Dec" label="12月" min-width="130" align="center">
							<template slot-scope="scope">{{ formatTableValue(scope.row.Dec, scope.row, scope.$index)
							}}</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>

		<!-- NTS平均价格功能区域 -->
		<div class="average-price-section">
			<div class="section-title">国内产品均价</div>
			<div class="search-area">
				<div class="search-item">
					<span class="label">年份：</span>
					<el-date-picker v-model="averagePriceForm.Year" type="year" placeholder="选择年份" size="small"
						style="width: 130px" value-format="yyyy" :editable="false"></el-date-picker>
				</div>
				<div class="search-item">
					<span class="label">月度区间：</span>
					<el-select v-model="averagePriceForm.MinMonth" placeholder="起始" size="small" style="width: 130px">
						<el-option v-for="item in 12" :key="item" :label="item + '月'" :value="item"></el-option>
					</el-select>
					<span style="margin: 0 5px;">-</span>
					<el-select v-model="averagePriceForm.MaxMonth" placeholder="结束" size="small" style="width: 130px">
						<el-option v-for="item in 12" :key="item" :label="item + '月'" :value="item"></el-option>
					</el-select>
				</div>
				<div class="search-item">
					<span class="label">渠道：</span>
					<el-select v-model="averagePriceForm.AccType" placeholder="请选择渠道" size="small" style="width: 130px">
						<el-option label="U8" value="U8"></el-option>
						<el-option label="U9" value="U9"></el-option>
					</el-select>
				</div>
				<div class="search-item">
					<span class="label">产品线：</span>
					<el-select v-model="averagePriceForm.InvClass" placeholder="请选择产品线" size="small"
						style="width: 150px" @change="handleInvClassChange">
						<el-option v-for="option in productLineOptions" :key="option.value" :label="option.label"
							:value="option.value"></el-option>
					</el-select>
				</div>
				<div class="search-item">
					<span class="label">LEVEL2：</span>
					<el-select v-model="averagePriceForm.LEVEL2" placeholder="请选择" size="small" style="width: 200px"
						clearable :disabled="!averagePriceForm.InvClass" multiple collapse-tags>
						<el-option v-for="item in level2Options" :key="item.Value" :label="item.Text"
							:value="item.Value"></el-option>
					</el-select>
				</div>
				<div class="search-item">
					<span class="label">LEVEL3：</span>
					<el-select v-model="averagePriceForm.LEVEL3" placeholder="请选择" size="small" style="width: 200px"
						clearable :disabled="!averagePriceForm.InvClass" multiple collapse-tags>
						<el-option v-for="item in level3Options" :key="item.Value" :label="item.Text"
							:value="item.Value"></el-option>
					</el-select>
				</div>
				<div class="search-item">
					<span class="label">产品名称：</span>
					<el-select style="width: 300px;" v-model="averagePriceForm.InvName" filterable remote
						reserve-keyword placeholder="请输入关键词" size="small" :remote-method="remoteMethod"
						:loading="productNameLoading" multiple collapse-tags :disabled="!averagePriceForm.InvClass"
						clearable>
						<el-option v-for="item in productNameOptions" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="button-group" style="transform: translateY(-4px);">
					<el-button size="small" @click="handleAveragePriceReset">重置</el-button>
					<el-button type="primary" size="small" @click="handleAveragePriceSearch">搜索</el-button>
					<el-button size="small" @click="handleAveragePriceExport">导出</el-button>
					<el-button size="small" class="refresh-btn" @click="handleAveragePriceRefresh"
						:loading="averagePriceRefreshing">刷新</el-button>
				</div>
			</div>

			<div class="content-area" style="background: transparent;box-shadow:none;">
				<el-spinner v-if="averagePriceLoading || !averagePriceData"
					style="margin: 20px auto; display: block;"></el-spinner>
				<div v-else class="chart-container">
					<!-- 图表网格 -->
					<div class="chart-grid"
						v-if="(averagePriceData.JAverPriceList && averagePriceData.JAverPriceList.length) || (averagePriceData.JAverPriceTotalList && averagePriceData.JAverPriceTotalList.length)">
						<!-- 左列图表 -->
						<div class="chart-column">
							<div v-for="(item, index) in averagePriceData.JAverPriceList" :key="'left-' + index"
								class="chart-wrapper">
								<el-card class="chart-card">
									<div slot="header" class="chart-header">
										<span>{{ getChartTitle(item, 'monthly') }}</span>
									</div>
									<div class="chart-content">
										<div :ref="'chartLeft-' + index" style="width: 100%; height: 300px;"></div>
									</div>
								</el-card>
							</div>
						</div>
						<!-- 右列图表 -->
						<div class="chart-column">
							<div v-for="(item, index) in averagePriceData.JAverPriceTotalList" :key="'right-' + index"
								class="chart-wrapper">
								<el-card class="chart-card">
									<div slot="header" class="chart-header">
										<span>{{ getChartTitle(item, 'ytd') }}</span>
									</div>
									<div class="chart-content">
										<div :ref="'chartRight-' + index" style="width: 100%; height: 300px;"></div>
									</div>
								</el-card>
							</div>
						</div>
					</div>
					<el-empty v-else description="暂无数据"></el-empty>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
import {
	RefreshNTSAveragePrice,
	GetNTSAveragePrice,
	ExportNTSAveragePrice,
	GetInvNameList,
	RefreshNTSInvClassQuotachievingRate,
	GetNTSInvClassQuotachievingRate,
	ExportNTSInvClassQuotachievingRate,
	GetLevel2List,
	GetLevel3List
} from '@/api/newsapi';
import {
	InventoryClassList
} from '@/api/home';
import Commontable from '@/components/common-table.vue';
import Pagination from '@/components/pagination.vue';

export default {
	name: 'U8NTSSchedult',
	components: {
		Commontable,
		Pagination
	},
	data() {
		return {
			// NTS指标达成率表单数据
			achievingRateForm: {
				Year: new Date().getFullYear().toString(),
				AccType: 'U9',
				InvClass: [],
				ByQuarter: '0' // 1季度、0月度
			},
			// NTS指标达成率数据
			achievingRateData: {
				JYearTD: {},
				JMonthTD: [],
				listRepost: []
			},
			achievingRateLoading: false,
			achievingRateRefreshing: false,

			// NTS平均价格表单数据
			averagePriceForm: {
				Year: new Date().getFullYear().toString(),
				MinMonth: '',
				MaxMonth: '',
				AccType: 'U9',
				InvClass: '',
				InvName: [],
				LEVEL2: [],
				LEVEL3: []
			},
			// NTS平均价格数据
			averagePriceData: {
				JAverPriceList: [],
				JAverPriceTotalList: []
			},
			averagePriceLoading: false,
			averagePriceRefreshing: false,
			productLineOptions: [], // 产品线下拉选项
			level2Options: [], // LEVEL2 下拉选项
			level3Options: [], // LEVEL3 下拉选项
			productNameOptions: [], // 产品名称搜索结果
			productNameLoading: false // 产品名称搜索加载状态
		};
	},
	mounted() {
		// 页面加载时默认搜索
		this.handleAchievingRateSearch();
		this.handleAveragePriceSearch();
		// 初始化产品线选项
		this.initProductLineOptions();
	},
	methods: {
		// 绘制指标达成率图表
		drawAchievingRateCharts() {
			const ytdDom = this.$refs.ytdChart;
			if (ytdDom) {
				this.initYTDChart(ytdDom, this.achievingRateData.JYearTD);
			}

			const monthlyDom = this.$refs.monthlyChart;
			if (monthlyDom) {
				this.initMonthlyAchievingChart(monthlyDom, this.achievingRateData.JMonthTD);
			}
		},
		// 初始化 YTD 年度达成率圆环图
		initYTDChart(dom, data) {
			if (!dom) return;
			let myChart = this.$MyEcharts.getInstanceByDom(dom);
			if (myChart) {
				myChart.dispose();
			}
			myChart = this.$MyEcharts.init(dom);

			const ratio = data.YTDRatio || 0;
			const quota = data.YearQuota || 0;
			const actual = data.YearTD || 0;

			const option = {
				title: [{
					text: '达成率',
					left: 'center',
					top: '42%',
					textStyle: {
						color: '#666',
						fontSize: 16,
						fontWeight: 'normal'
					}
				}, {
					text: ratio + '%',
					left: 'center',
					top: '52%',
					textStyle: {
						color: '#E71D43',
						fontSize: 24,
						fontWeight: 'bold'
					}
				}, {
					text: `YTD (年度达成) 【单位： NTS】：${actual.toLocaleString()}`,
					left: 'center',
					top: '2%',
					textStyle: {
						color: '#333',
						fontSize: 14,
						fontWeight: 'normal'
					}
				}, {
					text: `YBP (年度目标)：${quota.toLocaleString()}`,
					left: 'center',
					bottom: '2%',
					textStyle: {
						color: '#333',
						fontSize: 14,
						fontWeight: 'normal'
					}
				}],
				series: [{
					type: 'pie',
					radius: ['55%', '70%'],
					center: ['50%', '50%'],
					silent: true,
					label: {
						show: false
					},
					data: [{
						value: ratio,
						itemStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 0,
									color: '#FF6B8B' // 渐变起始色
								}, {
									offset: 1,
									color: '#E71D43' // 渐变结束色
								}]
							}
						}
					},
					{
						value: 100 - ratio > 0 ? 100 - ratio : 0,
						itemStyle: {
							color: '#f0f0f0'
						}
					}
					]
				}]
			};

			myChart.setOption(option);
			window.addEventListener("resize", () => {
				myChart.resize();
			});
		},
		// 初始化月度/季度达成率对比柱状图
		initMonthlyAchievingChart(dom, dataList) {
			if (!dom || !dataList) return;
			let myChart = this.$MyEcharts.getInstanceByDom(dom);
			if (myChart) {
				myChart.dispose();
			}
			myChart = this.$MyEcharts.init(dom);

			const xAxisData = dataList.map(item => item.ReportDate);
			const targetData = [];
			const actualData = [];
			const ratioData = [];

			dataList.forEach(item => {
				ratioData.push(item.TDRatio !== undefined && item.TDRatio !== null ? item.TDRatio : 0);
				const targetItem = item.Items.find(i => i.Name === '指标');
				const actualItem = item.Items.find(i => i.Name === '达成');
				targetData.push(targetItem ? targetItem.Money : 0);
				actualData.push(actualItem ? actualItem.Money : 0);
			});

			const option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					formatter: function (params) {
						let res = params[0].name + '<br/>';
						params.forEach(item => {
							let val = item.value !== undefined && item.value !== null ? item.value : 0;
							if (item.seriesName === '达成率') {
								val = val + '%';
							} else {
								val = (Number(val) / 10000).toLocaleString() + '万元';
							}
							res += item.marker + item.seriesName + ': ' + val + '<br/>';
						});
						return res;
					}
				},
				legend: {
					data: ['指标', '达成', '达成率'],
					bottom: 0
				},
				grid: {
					left: '3%',
					right: '4%',
					top: '15%',
					bottom: '10%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: xAxisData,
					axisTick: {
						alignWithLabel: true
					}
				},
				yAxis: [{
					type: 'value',
					name: '金额：万元',
					nameTextStyle: {
						padding: [0, 50, 0, 0]
					},
					axisLabel: {
						formatter: function (value) {
							return (value / 10000).toLocaleString();
						}
					}
				}, {
					type: 'value',
					name: '达成率',
					axisLabel: {
						formatter: '{value}%'
					},
					splitLine: {
						show: false
					}
				}],
				series: [{
					name: '指标',
					type: 'bar',
					barWidth: '20%',
					data: targetData,
					itemStyle: {
						color: '#E71D43'
					}
				},
				{
					name: '达成',
					type: 'bar',
					barWidth: '20%',
					data: actualData,
					itemStyle: {
						color: '#00266D'
					}
				},
				{
					name: '达成率',
					type: 'line',
					smooth: true,
					yAxisIndex: 1,
					data: ratioData,
					symbol: 'circle',
					symbolSize: 8,
					itemStyle: {
						color: '#333'
					},
					label: {
						show: true,
						position: 'top',
						formatter: '{c}%',
						fontSize: 10
					},
					lineStyle: {
						color: '#333',
						width: 1
					}
				}
				]
			};

			myChart.setOption(option);
			window.addEventListener("resize", () => {
				myChart.resize();
			});
		},
		// NTS指标达成率重置按钮点击事件
		handleAchievingRateReset() {
			this.achievingRateForm = {
				Year: new Date().getFullYear().toString(),
				AccType: 'U9',
				InvClass: [],
				ByQuarter: '0' // 1季度、0月度
			};
			this.handleAchievingRateSearch();
		},
		// 达成率表格表头样式
		getAchievingRateHeaderStyle({ row, column, rowIndex, columnIndex }) {
			const redColumns = ['Q1', 'Q2', 'Q3', 'Q4'];
			if (redColumns.includes(column.property)) {
				return {
					backgroundColor: '#E71D43', // 主题红色
					color: '#fff',
					textAlign: 'center'
				};
			}
			return {
				backgroundColor: '#00266D', // 主题深蓝色
				color: '#fff',
				textAlign: 'center'
			};
		},
		// 表格行样式
		tableRowClassName() {
			return 'compact-row';
		},
		// 格式化表格数据
		formatTableValue(val, row, index) {
			if (val === null || val === undefined || val === '') return '';

			const list = this.achievingRateData.listRepost || this.achievingRateData.listReport || [];
			// 达成率的判断：如果是最后一行或者行名包含达成率
			const isRate = (row.InvClassName && row.InvClassName.indexOf('达成率') !== -1) || index === list.length - 1;

			if (isRate) {
				if (String(val).indexOf('%') !== -1) return val;
				return val + '%';
			}

			if (typeof val === 'string' && val.indexOf(',') !== -1) return val;

			const num = Number(val);
			if (isNaN(num)) return val;

			return Math.round(num).toLocaleString();
		},
		// NTS指标达成率导出
		handleAchievingRateExport() {
			const params = {
				Year: this.achievingRateForm.Year
			};
			if (Array.isArray(this.achievingRateForm.InvClass) && this.achievingRateForm.InvClass.length > 0) {
				params.InvClass = this.achievingRateForm.InvClass.join(',');
			} else {
				params.InvClass = '';
			}

			ExportNTSInvClassQuotachievingRate(params)
				.then(res => {
					const blob = new Blob([res]);
					const fileName = '产品线NTS达成.xlsx';
					const link = document.createElement('a');
					link.href = window.URL.createObjectURL(blob);
					link.download = fileName;
					link.click();
					window.URL.revokeObjectURL(link.href);
				})
				.catch(err => {
					this.$message.error('导出失败');
				});
		},
		// NTS指标达成率搜索按钮点击事件
		handleAchievingRateSearch() {
			this.achievingRateLoading = true;
			const params = {
				...this.achievingRateForm
			};
			if (Array.isArray(params.InvClass) && params.InvClass.length > 0) {
				params.InvClass = params.InvClass.join(',');
			} else {
				params.InvClass = '';
			}
			GetNTSInvClassQuotachievingRate(params)
				.then(res => {
					if (res.code === 0) {
						this.achievingRateData = res.data;
					} else {
						this.achievingRateData = {
							JYearTD: {},
							JMonthTD: [],
							listRepost: []
						};
						this.$message.error(res.message || '获取数据失败');
					}
				})
				.catch(err => {
					this.achievingRateData = {
						JYearTD: {},
						JMonthTD: [],
						listRepost: []
					};
					const errorMessage = err.response?.data?.message || '获取数据失败';
					this.$message.error(errorMessage);
				})
				.finally(() => {
					this.achievingRateLoading = false;
					this.$nextTick(() => {
						this.drawAchievingRateCharts();
					});
				});
		},
		// NTS指标达成率刷新按钮点击事件
		handleAchievingRateRefresh() {
			this.achievingRateRefreshing = true;
			const params = {
				...this.achievingRateForm
			};
			if (Array.isArray(params.InvClass) && params.InvClass.length > 0) {
				params.InvClass = params.InvClass.join(',');
			} else {
				params.InvClass = '';
			}
			RefreshNTSInvClassQuotachievingRate(params)
				.then(res => {
					if (res.code === 0) {
						this.$message.success('刷新成功');
						this.handleAchievingRateSearch();
					} else {
						this.$message.error(res.message || '刷新失败');
					}
				})
				.catch(err => {
					const errorMessage = err.response?.data?.message || '刷新失败';
					this.$message.error(errorMessage);
				})
				.finally(() => {
					this.achievingRateRefreshing = false;
				});
		},
		// 初始化产品线选项
		initProductLineOptions() {
			// 调用API获取产品线列表
			InventoryClassList().then(res => {
				if (res.code === 0) {
					this.productLineOptions = res.data.data.map(item => ({
						value: item.InvClass,
						label: item.InvClassName
					}));
				}
			}).catch(err => {
				console.error('获取产品线列表失败:', err);
			});
		},
		// 产品线变化事件
		handleInvClassChange() {
			// 清空产品名称
			this.averagePriceForm.InvName = [];
			this.averagePriceForm.LEVEL2 = '';
			this.averagePriceForm.LEVEL3 = '';
			this.getLevel2Options();
			this.getLevel3Options();
		},
		// 获取LEVEL2下拉选项
		getLevel2Options() {
			if (!this.averagePriceForm.InvClass) {
				this.level2Options = [];
				return;
			}
			GetLevel2List({
				InvClass: this.averagePriceForm.InvClass
			}).then(res => {
				if (res.code === 0) {
					this.level2Options = res.data;
				} else {
					this.level2Options = [];
				}
			}).catch(() => {
				this.level2Options = [];
			});
		},
		// 获取LEVEL3下拉选项
		getLevel3Options() {
			if (!this.averagePriceForm.InvClass) {
				this.level3Options = [];
				return;
			}
			GetLevel3List({
				InvClass: this.averagePriceForm.InvClass
			}).then(res => {
				if (res.code === 0) {
					this.level3Options = res.data;
				} else {
					this.level3Options = [];
				}
			}).catch(() => {
				this.level3Options = [];
			});
		},
		// 产品名称远程搜索方法
		remoteMethod(queryString) {
			if (!this.averagePriceForm.InvClass) {
				this.productNameOptions = [];
				return;
			}

			this.productNameLoading = true;
			GetInvNameList({
				InvClass: this.averagePriceForm.InvClass,
				InvName: queryString
			})
				.then(res => {
					if (res.code === 0) {
						this.productNameOptions = res.data.map(item => ({
							value: item.InvName,
							label: item.InvName
						}));
					} else {
						this.productNameOptions = [];
					}
				})
				.catch(() => {
					this.productNameOptions = [];
				})
				.finally(() => {
					this.productNameLoading = false;
				});
		},
		// 获取图表标题
		getChartTitle(item, type) {
			const productName = Object.keys(item)[0] || '';
			const year = this.averagePriceForm.Year || new Date().getFullYear();
			const prefix = type === 'monthly' ? '月度 ' : (type === 'ytd' ? 'YTD ' : '');
			return `${prefix}${year}年主要产品ASP均价-${productName}`;
		},
		// 绘制所有图表
		drawCharts() {
			// 绘制左侧列图表
			if (this.averagePriceData.JAverPriceList) {
				this.averagePriceData.JAverPriceList.forEach((item, index) => {
					const refName = 'chartLeft-' + index;
					const domArray = this.$refs[refName];
					const dom = Array.isArray(domArray) ? domArray[0] : domArray;
					if (dom) {
						const title = Object.keys(item)[0];
						const data = item[title];
						if (data) {
							this.initChart(dom, title, data);
						}
					}
				});
			}

			// 绘制右侧列图表
			if (this.averagePriceData.JAverPriceTotalList) {
				this.averagePriceData.JAverPriceTotalList.forEach((item, index) => {
					const refName = 'chartRight-' + index;
					const domArray = this.$refs[refName];
					const dom = Array.isArray(domArray) ? domArray[0] : domArray;
					if (dom) {
						const title = Object.keys(item)[0];
						const data = item[title];
						if (data) {
							this.initChart(dom, title, data);
						}
					}
				});
			}
		},
		// 初始化单个图表
		initChart(dom, title, data) {
			if (!dom) return;
			// 如果已经有实例，先销毁
			let myChart = this.$MyEcharts.getInstanceByDom(dom);
			if (myChart) {
				myChart.dispose();
			}
			myChart = this.$MyEcharts.init(dom);

			// 处理数据
			const xAxisData = data.map(item => item.ReportDate);
			const seriesMap = {};

			// 收集所有系列数据
			data.forEach(monthItem => {
				monthItem.Items.forEach(seriesItem => {
					if (!seriesMap[seriesItem.Name]) {
						seriesMap[seriesItem.Name] = [];
					}
				});
			});

			// 填充系列数据
			const seriesNames = Object.keys(seriesMap);
			data.forEach(monthItem => {
				seriesNames.forEach(name => {
					const found = monthItem.Items.find(i => i.Name === name);
					seriesMap[name].push(found ? found.Money : 0);
				});
			});

			const series = seriesNames.map((name, idx) => ({
				name: name,
				type: 'line',
				smooth: true,
				// 根据索引设置虚线或实线，匹配截图效果
				lineStyle: {
					width: 2,
					type: idx % 2 === 0 ? 'solid' : 'dashed'
				},
				data: seriesMap[name],
				label: {
					show: true,
					position: 'top',
					formatter: function (params) {
						if (!params.value) return '';
						return params.value.toLocaleString();
					},
					fontSize: 10,
					color: '#666'
				},
				// 自动隐藏重叠的标签，解决堆叠问题
				labelLayout: {
					hideOverlap: false
				},
				symbol: 'circle',
				symbolSize: 6,
				itemStyle: {
					color: name.indexOf('一级') > -1 ? '#00266D' : (name.indexOf('二级') > -1 ? '#E71D43' :
						undefined)
				}
			}));

			const option = {
				color: ['#A9D18E', '#BDD7EE', '#F4B183', '#8497B0'], // 匹配截图配色
				tooltip: {
					trigger: 'axis',
					formatter: function (params) {
						let res = params[0].name + '<br/>';
						params.forEach(item => {
							let seriesName = item.seriesName;
							if (seriesName.indexOf('-') !== -1) {
								seriesName = seriesName.split('-')[0];
							}
							res += item.marker + seriesName + ': ' + item.value.toLocaleString() +
								'<br/>';
						});
						return res;
					}
				},
				legend: {
					data: seriesNames,
					bottom: 10,
					icon: 'rect'
				},
				grid: {
					left: '10%', // 改为百分比，或更大的像素值，确保左侧金额显示完整
					right: '5%',
					top: '40',
					bottom: '60',
					containLabel: true // 包含坐标轴标签在内的内容都计算在内，防止溢出
				},
				xAxis: {
					type: 'category',
					boundaryGap: true,
					data: xAxisData,
					axisTick: {
						alignWithLabel: true
					}
				},
				yAxis: {
					type: 'value',
					name: '单位:元',
					nameTextStyle: {
						padding: [0, 50, 0, 0]
					},
					min: function (value) {
						// 自动计算最小值，留出空间
						return Math.floor(value.min * 0.8 / 100) * 100;
					},
					axisLabel: {
						formatter: function (value) {
							return value.toLocaleString();
						}
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: 'dashed'
						}
					}
				},
				series: series
			};

			myChart.setOption(option);

			// 监听窗口大小变化
			window.addEventListener("resize", () => {
				myChart.resize();
			});
		},
		// NTS平均价格重置按钮点击事件
		handleAveragePriceReset() {
			this.averagePriceForm = {
				Year: new Date().getFullYear().toString(),
				MinMonth: '',
				MaxMonth: '',
				AccType: 'U9',
				InvClass: '',
				InvName: [],
				LEVEL2: [],
				LEVEL3: []
			};
			this.productNameOptions = [];
			this.level2Options = [];
			this.level3Options = [];
			this.handleAveragePriceSearch();
		},
		// NTS平均价格搜索按钮点击事件
		handleAveragePriceSearch() {
			this.averagePriceLoading = true;
			// 构造请求参数
			const params = {
				...this.averagePriceForm
			};
			// 如果InvName是数组，转换为逗号分隔的字符串
			if (Array.isArray(params.InvName) && params.InvName.length > 0) {
				params.InvName = params.InvName.join(',');
			} else {
				params.InvName = ''; // 如果为空数组或未选择，传空字符串
			}
			// 如果LEVEL2是数组，转换为逗号分隔的字符串
			if (Array.isArray(params.LEVEL2) && params.LEVEL2.length > 0) {
				params.LEVEL2 = params.LEVEL2.join(',');
			} else {
				params.LEVEL2 = ''; // 如果为空数组或未选择，传空字符串
			}
			// 如果LEVEL3是数组，转换为逗号分隔的字符串
			if (Array.isArray(params.LEVEL3) && params.LEVEL3.length > 0) {
				params.LEVEL3 = params.LEVEL3.join(',');
			} else {
				params.LEVEL3 = ''; // 如果为空数组或未选择，传空字符串
			}

			GetNTSAveragePrice(params)
				.then(res => {
					if (res.code === 0) {
						this.averagePriceData = res.data;
					} else {
						this.averagePriceData = {
							JAverPriceList: [],
							JAverPriceTotalList: []
						};
						this.$message.error(res.message || '获取数据失败');
					}
				})
				.catch(err => {
					this.averagePriceData = {
						JAverPriceList: [],
						JAverPriceTotalList: []
					};
					const errorMessage = err.response?.data?.message || '获取数据失败';
					this.$message.error(errorMessage);
				})
				.finally(() => {
					this.averagePriceLoading = false;
					// 必须在 loading 变为 false 且 nextTick 后，DOM 才会真正渲染
					this.$nextTick(() => {
						this.drawCharts();
					});
				});
		},
		// NTS平均价格刷新按钮点击事件
		handleAveragePriceRefresh() {
			this.averagePriceRefreshing = true;
			// 构造请求参数
			const params = {
				...this.averagePriceForm
			};
			// 如果InvName是数组，转换为逗号分隔的字符串
			if (Array.isArray(params.InvName) && params.InvName.length > 0) {
				params.InvName = params.InvName.join(',');
			} else {
				params.InvName = ''; // 如果为空数组或未选择，传空字符串
			}
			// 如果LEVEL2是数组，转换为逗号分隔的字符串
			if (Array.isArray(params.LEVEL2) && params.LEVEL2.length > 0) {
				params.LEVEL2 = params.LEVEL2.join(',');
			} else {
				params.LEVEL2 = ''; // 如果为空数组或未选择，传空字符串
			}
			// 如果LEVEL3是数组，转换为逗号分隔的字符串
			if (Array.isArray(params.LEVEL3) && params.LEVEL3.length > 0) {
				params.LEVEL3 = params.LEVEL3.join(',');
			} else {
				params.LEVEL3 = ''; // 如果为空数组或未选择，传空字符串
			}

			RefreshNTSAveragePrice(params)
				.then(res => {
					if (res.code === 0) {
						this.$message.success('刷新成功');
						// 刷新成功后重新获取数据
						this.handleAveragePriceSearch();
					} else {
						this.$message.error(res.message || '刷新失败');
					}
				})
				.catch(err => {
					// 捕获到错误时，尝试从err.response.data中获取message
					const errorMessage = err.response?.data?.message || '刷新失败';
					this.$message.error(errorMessage);
				})
				.finally(() => {
					this.averagePriceRefreshing = false;
				});
		},
		// NTS平均价格导出按钮点击事件
		handleAveragePriceExport() {
			// 构造请求参数
			const params = {
				...this.averagePriceForm
			};
			// 如果InvName是数组，转换为逗号分隔的字符串
			if (Array.isArray(params.InvName) && params.InvName.length > 0) {
				params.InvName = params.InvName.join(',');
			} else {
				params.InvName = ''; // 如果为空数组或未选择，传空字符串
			}
			// 如果LEVEL2是数组，转换为逗号分隔的字符串
			if (Array.isArray(params.LEVEL2) && params.LEVEL2.length > 0) {
				params.LEVEL2 = params.LEVEL2.join(',');
			} else {
				params.LEVEL2 = ''; // 如果为空数组或未选择，传空字符串
			}
			// 如果LEVEL3是数组，转换为逗号分隔的字符串
			if (Array.isArray(params.LEVEL3) && params.LEVEL3.length > 0) {
				params.LEVEL3 = params.LEVEL3.join(',');
			} else {
				params.LEVEL3 = ''; // 如果为空数组或未选择，传空字符串
			}

			ExportNTSAveragePrice(params)
				.then(res => {
					const blob = new Blob([res]);
					const fileName = '国内产品均价.xlsx';
					const link = document.createElement('a');
					link.href = window.URL.createObjectURL(blob);
					link.download = fileName;
					link.click();
					window.URL.revokeObjectURL(link.href);
				})
				.catch(err => {
					this.$message.error('导出失败');
				});
		},

	},
}
</script>

<style scoped>
.u8-nts-schedule {
	/* padding: 20px;
		background-color: #FFF; */
}

.average-price-section {
	margin-bottom: 20px;
}

.achieving-rate-section {
	margin-bottom: 20px;
}

.achieving-rate-container {
	display: flex;
	justify-content: space-between;
	gap: 20px;
	padding: 20px;
}

.ytd-chart-box {
	width: 350px;
	background: #fff;
	border-radius: 4px;
	/* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
}

.monthly-chart-box {
	flex: 1;
	background: #fff;
	border-radius: 4px;
	/* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
}

.achieving-rate-content {
	min-height: 300px !important;
}

.section-title {
	font-size: 16px;
	font-weight: bold;
	color: #303133;
	margin-bottom: 15px;
	padding-left: 5px;
}

.search-area {
	background-color: #fff;
	padding: 20px;
	border-radius: 4px;
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 15px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.search-item {
	margin-right: 15px;
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}

.label {
	margin-right: 10px;
	font-size: 14px;
	color: #606266;
}

.button-group {
	margin-left: auto;
	/* margin-top: 10px; */
}

.button-group .el-button {
	margin-left: 10px;
}

.refresh-btn {
	background-color: #00266D !important;
	color: #fff !important;
	border-color: #00266D !important;
}

.refresh-btn:hover,
.refresh-btn:focus {
	background-color: #00338d !important;
	border-color: #00338d !important;
	color: #fff !important;
}

.refresh-btn.is-loading {
	opacity: 0.8;
}

.content-area {
	min-height: 400px;
	background: #FFFFFF;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.data-container {
	margin: 0;
}

/* 图表区域样式 */
.chart-container {
	/* margin-top: 20px; */
}

.chart-column-title {
	font-size: 14px;
	font-weight: bold;
	color: #303133;
	margin-bottom: 10px;
	text-align: center;
}

.chart-grid {
	display: flex;
	justify-content: space-between;
	gap: 20px;
}

.chart-column {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 20px;
}

.chart-card {
	border-radius: 4px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.chart-header {
	font-size: 14px;
	font-weight: bold;
	color: #303133;
	text-align: center;
}

.chart-content {
	height: 300px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.chart-placeholder {
	font-size: 14px;
	color: #909399;
	padding: 20px;
}

::v-deep .el-select__input.is-small {
	border: none !important;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner,
::v-deep .el-select .el-input__inner,
::v-deep .el-date-editor.el-input__inner {
	transition: all 0.8s;
	border-radius: 0px;
}

::v-deep .el-input__inner:focus,
::v-deep .el-textarea__inner:focus,
::v-deep .el-select.is-focus .el-input__inner,
::v-deep .el-date-editor.is-focus .el-input__inner {
	border: 1px solid #e71d43 !important;
}

/* 达成率表格紧凑行高 */
::v-deep .el-table .compact-row td,
::v-deep .el-table .compact-row {
	height: 36px !important;
	padding: 0 !important;
}

::v-deep .el-table .compact-row .cell {
	line-height: 36px !important;
	padding-left: 8px !important;
	padding-right: 8px !important;
}

/* 达成率表格表头紧凑高度 */
::v-deep .el-table__header th,
::v-deep .el-table__header-wrapper th {
	height: 40px !important;
	padding: 0 !important;
}

::v-deep .el-table__header .cell {
	line-height: 40px !important;
	padding-left: 8px !important;
	padding-right: 8px !important;
}
</style>